import Axios from "axios";

export default function TypeProgramList(selectedEntranceId){
    console.log(selectedEntranceId);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'selectProgram',
            selectedEntranceId
        }
    });
    return response;
}